import { FeatureFlag, Site } from '@ps/web-core-enums';
import React from 'react';
import { useSelector } from 'react-redux';

import { Validation } from '@swf/components/Inputs/Input';
import SWPassword from '@swf/components/Inputs/Password';
import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';
import {
  checkUserPassword,
  minLength as minLengthFactory,
  mustContainNumber,
  mustContainSymbol,
  mustContainUpperCaseLetter,
  mustNotIncludeFieldValue,
  mustStartWithLetter
} from '@swf/core/utils/validators';

import { label, root } from '../TextInput/TextInput.scss';

import {
  TXTCLI_Password,
  TXTWCL_At_least_one_capital_letter_XA_ELL,
  TXTWCL_At_least_one_symbol_XeXgX_XX,
  TXTWCL_Have_at_least_1_number,
  TXTWCL_N0_characters_or_more,
  TXTWCL_Start_with_a_letter
} from './Password.messages.json';

const maxLength = 20;
const minLength = 8;

const siteSpecificValidators = {
  [Site.ES]: [
    mustContainSymbol(TXTWCL_At_least_one_symbol_XeXgX_XX),
    mustContainUpperCaseLetter(TXTWCL_At_least_one_capital_letter_XA_ELL)
  ]
};

const Password = () => {
  const site = useSelector(select.cms.getSiteId);
  const isAutofocusEnabled = useFeature(FeatureFlag.SwcSignupRmfAutofocus);
  const isSignupOneEnabled = useFeature(FeatureFlag.SwcSignupOnePage);

  return (
    <SWPassword
      id="password"
      className={root}
      maxLength={maxLength}
      autoComplete="off"
      labelClassName={label}
      validationVariant={Validation.ImmediateList}
      label={TXTCLI_Password}
      validators={[
        minLengthFactory(minLength, { ...TXTWCL_N0_characters_or_more, values: { 0: minLength } }),
        mustStartWithLetter(TXTWCL_Start_with_a_letter),
        mustContainNumber(TXTWCL_Have_at_least_1_number),
        ...(siteSpecificValidators[site] ?? []),
        mustNotIncludeFieldValue('userId'),
        checkUserPassword
      ]}
      autoFocus={isAutofocusEnabled && !isSignupOneEnabled}
    />
  );
};

export default Password;
